<div class="button-wrapper" matTooltip="{{ 'Unsubscribe.button-tooltip' | translate }}" [matTooltipPosition]="'above'" [matTooltipDisabled]="isEnabled === true">
  <a class="tiny-link footer-link" name="unsubscribe-open" (click)="isEnabled === false ? '' : showUnsubscribePopin()">{{ 'Unsubscribe.button' | translate }}</a>
</div>

<ng-template #dialog>
  <i class="bi bi-x-lg close-dialog" mat-dialog-close></i>
  <h3 mat-dialog-title [translate]="'Unsubscribe.title'"></h3>
  @if (unsubscribeForm) {
    <form [formGroup]="unsubscribeForm" #unsubscribe="ngForm" (ngSubmit)="askUnsubscribe()">
      <div class="stepper-container">
        <mat-stepper orientation="horizontal" #unsubscribeStepper (selectionChange)="stepChanged($event)">
          <mat-step>
            <mat-dialog-content>
              <p [translate]="'UnsubscribeV2.Step1.intro'"></p>
              <p [translate]="'UnsubscribeV2.Step1.intro2'"></p>
              <h5 class="black-text" [translate]="'UnsubscribeV2.Step1.important'"></h5>
              <h5 class="black-text" [translate]="'UnsubscribeV2.Step1.important2'"></h5>
              <p>
                {{ 'UnsubscribeV2.Step1.info' | translate }}
                <a routerLink="/factures" (click)="closeUnsubscribePopin()">{{ 'UnsubscribeV2.Step1.link' | translate }}</a
                >{{ 'UnsubscribeV2.Step1.info2' | translate }}
              </p>
            </mat-dialog-content>
            <mat-dialog-actions class="one-button">
              <button gs1Button [name]="'unsubscribe-step1-confirm'" [thin]="true" matStepperNext type="button">
                {{ 'UnsubscribeV2.Step1.process' | translate }}
              </button>
            </mat-dialog-actions>
          </mat-step>
          <mat-step>
            <mat-dialog-content>
              <h4 [translate]="'UnsubscribeV2.Step2.title1'" class="gs1-color-blue title1"></h4>
              <p [translate]="'UnsubscribeV2.Step2.text11'"></p>
              <p [translate]="'UnsubscribeV2.Step2.text12'"></p>
              <h4 [translate]="'UnsubscribeV2.Step2.title2'" class="gs1-color-blue title2"></h4>
              <p [translate]="'UnsubscribeV2.Step2.text21'"></p>
              <p [translate]="'UnsubscribeV2.Step2.text22'"></p>
              <p [translate]="'UnsubscribeV2.Step2.text23'"></p>
              <gs1-checkbox [name]="'unsubscribe-consent'" formControlName="acceptUnsubscribe">
                <p>
                  {{ 'UnsubscribeV2.Step2.checkbox' | translate }}
                </p>
              </gs1-checkbox>
            </mat-dialog-content>
            <mat-dialog-actions>
              <button gs1Button [name]="'unsubscribe-step2-cancel'" [thin]="true" [appearance]="'outlined'" matStepperPrevious type="button">
                {{ 'UnsubscribeV2.Step2.returnbutton' | translate }}
              </button>
              <button
                gs1Button
                [name]="'unsubscribe-step2-confirm'"
                [thin]="true"
                matStepperNext
                type="button"
                [disabled]="unsubscribeForm.get('acceptUnsubscribe').value !== true"
              >
                {{ 'UnsubscribeV2.Step2.nextbutton' | translate }}
              </button>
            </mat-dialog-actions>
          </mat-step>
          <mat-step>
            <mat-dialog-content>
              <h5>
                {{ (company.isBadPayer !== false ? 'Unsubscribe.Step3.badpayer' : 'Unsubscribe.Step3.goodpayer') | translate }}
              </h5>
              <h5 [translate]="'Unsubscribe.Step3.sorry'" style="margin-bottom: 0"></h5>
              <gs1-radios [hasState]="false" [label]="'Unsubscribe.Step3.reason' | translate">
                <gs1-radio formControlName="reason" name="reason-judicialliquidation" [value]="'judicialliquidation'">
                  <span matTooltip="{{ 'Unsubscribe.Step3.judicialliquidation.tooltip' | translate }}" [matTooltipPosition]="'right'">{{
                    'Unsubscribe.Step3.judicialliquidation.title' | translate
                  }}</span>
                </gs1-radio>
                <gs1-radio formControlName="reason" name="reason-totalTermination" [value]="'totalTermination'">
                  <span matTooltip="{{ 'Unsubscribe.Step3.totalTermination.tooltip' | translate }}" [matTooltipPosition]="'right'">{{
                    'Unsubscribe.Step3.totalTermination.title' | translate
                  }}</span>
                </gs1-radio>
                <gs1-radio formControlName="reason" name="reason-partialTermination" [value]="'partialTermination'">
                  <span matTooltip="{{ 'Unsubscribe.Step3.partialTermination.tooltip' | translate }}" [matTooltipPosition]="'right'">{{
                    'Unsubscribe.Step3.partialTermination.title' | translate
                  }}</span>
                </gs1-radio>
              </gs1-radios>
              <gs1-phone [label]="'Unsubscribe.Step3.coord' | translate" [linear]="true" [name]="'phoneNumber'" formControlName="phoneNumber" #phoneNumber></gs1-phone>
            </mat-dialog-content>
            <mat-dialog-actions>
              <button gs1Button [name]="'unsubscribe-step3-cancel'" [thin]="true" [appearance]="'outlined'" matStepperPrevious type="button">
                {{ 'Unsubscribe.Step3.cancel' | translate }}
              </button>
              <button gs1Button [name]="'unsubscribe-step3-confirm'" [thin]="true" [disabled]="unsubscribeForm.valid !== true" type="submit">
                {{ 'Unsubscribe.Step3.process' | translate }}
              </button>
            </mat-dialog-actions>
          </mat-step>
        </mat-stepper>
      </div>
    </form>
  }
</ng-template>
